<div
  class="container anzco plain-background"
  [appLoader]="{show: activeSpinner | async}">
  <router-outlet></router-outlet>
</div>
